import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { duplicate_role_by_id, fetch_all_roles } from '../../api/roleAPI'
import notify from '../../utils/IANotification'
import DataTable from '../../components/ui/DataTable'
import AdminLayout from '../../layouts/AdminLayout'
import Button from '../../components/ui/Button'
import { tidy_date, tidy_time_difference } from '../../utils/helper'
import { MdAdd, MdCheck, MdCopyAll, MdEdit } from 'react-icons/md'

export default function RolePermissionPage() {
  const navigate = useNavigate()
  const [pageData, setPageData] = useState([])

  const fetchRolePermissionData = async () => {
    let { data, error, message } = await fetch_all_roles()
    if (error) return console.error(message)
    data = data.sort((a, b) => a.permissions.length - b.permissions.length)
    setPageData(data)
  }

  useEffect(() => {
    fetchRolePermissionData()
  }, [])

  const isFullAccess = (role) => {
    if (role.is_super_admin == 1) return true
    const resAccess = role?.resource_access || {}
    const keys = Object.keys(resAccess)
    if (keys.length === 0) return true
    return keys.every(key => Array.isArray(resAccess[key]) && resAccess[key].includes("*"))
  }

  const table_columns = [
    { header: 'Role', accessor: 'name' },
    { header: 'Super Admin', accessor: 'is_super_admin', modifier: (data) => data == 1 ? <MdCheck className="text-emerald-600 font-bold text-lg" /> : null },
    { header: 'Default User', accessor: 'is_default_user', modifier: (data) => data == 1 ? <MdCheck /> : null },
    {
      header: 'Access Scope',
      accessor: 'resource_access',
      modifier: (data, row) => {
        const full = isFullAccess(row)
        return (
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${full
            ? 'bg-emerald-100 text-emerald-800'
            : 'bg-amber-100 text-amber-800'
            }`}>
            {full ? "Full Access (*)" : "Limited Scope"}
          </span>
        )
      }
    },
    { header: 'Permissions', accessor: 'permissions', modifier: (data) => `${data?.length || 0} permissions` },
    { header: "Last Updated", accessor: "updatedAt", modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})` }
  ]

  return (
    <AdminLayout
      navSelected={"Roles & Permissions"}
      headerText={"Role Permissions"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Roles & Permissions</h1>
          <Button
            variant="primary"
            icon={MdAdd}
            onClick={() => {
              navigate("/admin/roles-permissions/details?role_id=new")
            }}
          >
            New Role
          </Button>
        </>
      }
    >
      <DataTable
        data={pageData}
        columns={table_columns}
        placeholder="No roles available"
        enableActions={true}
        onRowSelect={(row) => navigate(`/admin/roles-permissions/details?role_id=${row.id}`)}
        enableSelection={false}
        accessorKey="id"
        tableName={"RolePermissionsTable"}
        actions={(row) => {
          return (
            <div className="flex gap-2">
              <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/roles-permissions/details?role_id=${row.id}`)}>
                Edit
              </Button>
              <Button
                variant="outline"
                size="sm"
                icon={MdCopyAll}
                onClick={async (e) => {
                  e.stopPropagation()
                  let { data, error, message } = await duplicate_role_by_id(row.id)
                  if (error) return notify({ message, type: "error" })
                  notify({ message: "Role duplicated successfully", type: "success" })
                  fetchRolePermissionData()
                }}
              >
                Duplicate
              </Button>
            </div>
          )
        }}
      />
    </AdminLayout>
  )
}
